<div class="test-container">
  <div class="header">
    <div class="logo">Imagine Apps</div>
    <div class="header-right">
      <input type="text" class="search-bar" placeholder="Buscar">
      <div class="language-selector-inline">
        <button class="lang-btn active" (click)="changeLanguage('es')" id="btn-es">🇪🇸 ES</button>
        <button class="lang-btn" (click)="changeLanguage('en')" id="btn-en">🇺🇸 EN</button>
      </div>
      <button class="btn">Iniciar sesión</button>
      <button class="btn">Crear cuenta</button>
    </div>
  </div>

  <div class="content">
    <h1>🌍 Test del Selector de Idioma</h1>
    
    <div class="status success">
      ✅ <strong>Selector implementado:</strong> Botones 🇪🇸 ES y 🇺🇸 EN
    </div>
    
    <div class="status info">
      ℹ️ <strong>Instrucciones:</strong> Haz clic en los botones de idioma para probar
    </div>

    <h2>🎯 Cómo Debería Funcionar:</h2>
    <ul>
      <li>Haz clic en 🇪🇸 ES → Se activa (fondo más claro)</li>
      <li>Haz clic en 🇺🇸 EN → Se activa (fondo más claro)</li>
      <li>Verifica en la consola: "Idioma cambiado a: es/en"</li>
      <li>Verifica en localStorage: "selectedLanguage"</li>
    </ul>

    <h2>🔍 Si No Funciona:</h2>
    <ul>
      <li>Verifica la consola del navegador (F12)</li>
      <li>Asegúrate de que JavaScript esté habilitado</li>
      <li>Prueba en un navegador diferente</li>
    </ul>

    <div class="status success">
      🎉 <strong>¡Si funciona aquí, el problema es de integración con el header principal!</strong>
    </div>
  </div>
</div>
